import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';
import { sanitizeSupabaseError } from '@/lib/errorHandler';
import { listarOSConsumer, obterOSConsumer, avaliarOSConsumer, type AvaliarOSInput } from '@/services/consumer-os.service';

export function useOSConsumer() {
  return useQuery({ queryKey: ['os-consumer'], queryFn: listarOSConsumer });
}

export function useOSConsumerDetalhe(osId: string | undefined) {
  return useQuery({
    queryKey: ['os-consumer-detalhe', osId],
    queryFn: () => obterOSConsumer(osId as string),
    enabled: !!osId,
  });
}

export function useAvaliarOS() {
  const qc = useQueryClient();
  const { t } = useTranslation();
  return useMutation({
    mutationFn: (input: AvaliarOSInput) => avaliarOSConsumer(input),
    onSuccess: (_id, input) => {
      qc.invalidateQueries({ queryKey: ['os-consumer'] });
      qc.invalidateQueries({ queryKey: ['os-consumer-detalhe', input.osId] });
      toast.success(t('myOrders.rated'));
    },
    onError: (e) => {
      const msg = e instanceof Error ? e.message : '';
      if (msg.includes('ja_avaliada')) { toast.error(t('myOrders.alreadyRated')); return; }
      if (msg.includes('os_nao_avaliavel')) { toast.error(t('myOrders.notRateable')); return; }
      if (msg.includes('nota_invalida')) { toast.error(t('myOrders.invalidRating')); return; }
      toast.error(sanitizeSupabaseError(e));
    },
  });
}
